(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  const cleanPageParagraphs = () => {
    document.querySelectorAll('.ocp-standard-page__body .rte > p').forEach((paragraph) => {
      const text = paragraph.textContent.replace(/\u00a0/g, '').trim();
      const hasMedia = paragraph.querySelector('img, iframe, video, svg');

      if (!text && !hasMedia) {
        paragraph.remove();
      }
    });
  };

  const enhanceFaqPage = () => {
    const page = document.querySelector('.ocp-standard-page--faq');
    const rte = page?.querySelector('.ocp-standard-page__body .rte');

    if (!rte || rte.dataset.enhanced === 'faq') return;

    const children = Array.from(rte.children).filter((child) => {
      return child.textContent.replace(/\u00a0/g, '').trim() || child.querySelector('img, iframe, video, svg');
    });
    const intro = children[0];
    const pairs = [];

    for (let index = 1; index < children.length; index += 1) {
      const question = children[index];
      const answer = children[index + 1];
      const questionText = question?.textContent.replace(/\s+/g, ' ').trim();
      const hasStrongQuestion = question?.tagName === 'P' && question.querySelector('strong');

      if (!question || !answer || !questionText || !hasStrongQuestion) continue;

      pairs.push({ question, answer });
      index += 1;
    }

    if (!pairs.length) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'ocp-faq-enhanced';

    if (intro) {
      const introBlock = document.createElement('div');
      introBlock.className = 'ocp-faq-enhanced__intro';
      introBlock.innerHTML = intro.innerHTML;
      wrapper.appendChild(introBlock);
    }

    const list = document.createElement('div');
    list.className = 'ocp-faq-enhanced__list';

    pairs.forEach(({ question, answer }, index) => {
      const item = document.createElement('details');
      item.className = 'ocp-faq-enhanced__item';
      if (index === 0) item.open = true;

      const summary = document.createElement('summary');
      summary.className = 'ocp-faq-enhanced__question';
      summary.textContent = question.textContent.replace(/\s+/g, ' ').trim();

      const answerBlock = document.createElement('div');
      answerBlock.className = 'ocp-faq-enhanced__answer';
      answerBlock.innerHTML = answer.innerHTML;

      item.append(summary, answerBlock);
      list.appendChild(item);
    });

    wrapper.appendChild(list);
    rte.replaceChildren(wrapper);
    rte.dataset.enhanced = 'faq';
  };

  cleanPageParagraphs();
  enhanceFaqPage();

  document.addEventListener('shopify:section:load', () => {
    cleanPageParagraphs();
    enhanceFaqPage();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocp-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNewsletter(root) {
    var form = root.querySelector('form');
    if (!form || form.dataset.ajaxBound) return;
    form.dataset.ajaxBound = 'true';
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var msg = root.querySelector('.newsletter__msg');
    var successText = root.getAttribute('data-success-message') || '';
    var errorText = root.getAttribute('data-error-message') || 'Something went wrong. Please try again.';

    function setMessage(text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle('newsletter__msg--error', !!isError);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (input && !input.checkValidity()) { input.reportValidity(); return; }
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      setMessage('', false);

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (response.ok) {
            setMessage(successText, false);
            if (input) input.value = '';
          } else {
            setMessage(errorText, true);
          }
        })
        .catch(function () { setMessage(errorText, true); })
        .finally(function () {
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        });
    });
  }

  document.querySelectorAll('[data-newsletter]').forEach(initNewsletter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocp-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-search]').forEach(function (wrap) {
    var inputs = Array.prototype.slice.call(wrap.querySelectorAll('[data-search-input]'));
    var panel = wrap.querySelector('[data-search-panel]');
    var close = wrap.querySelector('[data-search-close]');
    var backdrop = wrap.querySelector('[data-search-backdrop]');
    var mobileTrigger = wrap.querySelector('[data-search-mobile-trigger]');
    var sug = wrap.querySelector('[data-search-suggestions]');
    var prod = wrap.querySelector('[data-search-products]');
    var searchBase = wrap.getAttribute('data-search-url') || '/search';
    if (!inputs.length || !panel) return;
    var timer, controller, outsideCloseAfter = 0;
    var mobileMq = window.matchMedia('(max-width: 700px)');
    var navInput = wrap.querySelector('.nav__search-input');

    function syncNavInputMode() {
      if (navInput) navInput.readOnly = mobileMq.matches;
    }
    syncNavInputMode();
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', syncNavInputMode);

    function show() {
      panel.hidden = false;
      wrap.classList.add('is-open');
      if (mobileMq.matches) { document.body.classList.add('is-search-open'); }
      inputs.forEach(function (i) { i.setAttribute('aria-expanded', 'true'); });
      if (mobileTrigger) mobileTrigger.setAttribute('aria-expanded', 'true');
    }
    function hide() {
      panel.hidden = true;
      wrap.classList.remove('is-open');
      document.body.classList.remove('is-search-open');
      inputs.forEach(function (i) { i.setAttribute('aria-expanded', 'false'); });
      if (mobileTrigger) mobileTrigger.setAttribute('aria-expanded', 'false');
    }
    function currentVal() { for (var i = 0; i < inputs.length; i++) { if (inputs[i].value.trim()) return inputs[i].value.trim(); } return ''; }
    function blurAll() { inputs.forEach(function (i) { i.blur(); }); }
    function syncVal(val, except) { inputs.forEach(function (i) { if (i !== except) i.value = val; }); }
    function clearResults() { if (sug) sug.innerHTML = ''; if (prod) prod.innerHTML = ''; if (panel) panel.classList.remove('has-products'); }
    // Review 07/07 (Search #2): "has-query" hides Popular Searches the instant the shopper types.
    function setQueried(on) { if (panel) panel.classList.toggle('has-query', !!on); }
    function focusVisible() { var v = inputs.filter(function (i) { return i.offsetParent !== null; })[0] || inputs[0]; v.focus(); }

    function ensureSuggestion(q) {
      if (!sug || !q) return;
      var needle = q.toLowerCase();
      var term = '';
      var href = '';
      Array.prototype.some.call(wrap.querySelectorAll('.search-pill[data-search-term]'), function (pill) {
        var candidate = (pill.getAttribute('data-search-term') || '').trim();
        if (candidate && candidate.toLowerCase().indexOf(needle) === 0) {
          term = candidate;
          href = pill.getAttribute('href') || '';
          return true;
        }
        return false;
      });
      if (!term) term = q;
      if (!href) href = searchBase + '?q=' + encodeURIComponent(term) + '&type=product';

      var list = sug.querySelector('.search-suggest');
      if (!list) {
        var section = document.createElement('div');
        section.className = 'search-pop__section';
        var title = document.createElement('h3');
        title.className = 'search-pop__title';
        title.textContent = panel.getAttribute('data-suggestions-label') || 'Suggestions';
        list = document.createElement('ul');
        list.className = 'search-suggest';
        section.appendChild(title);
        section.appendChild(list);
        sug.appendChild(section);
      }

      var alreadyShown = Array.prototype.some.call(list.querySelectorAll('a'), function (link) {
        return link.textContent.trim().toLowerCase() === term.toLowerCase();
      });
      if (!alreadyShown) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = href;
        link.textContent = term;
        item.appendChild(link);
        list.insertBefore(item, list.firstChild);
      }
    }

    function run(q) {
      if (!q || q.length < 2) { clearResults(); return; }
      if (controller) { controller.abort(); }
      controller = new AbortController();
      // Search titles AND tags + product type + description so terms like "cotton" (which live in
      // tags/body, not the fabric-name titles) return full results. Higher limit per best practice.
      var url = '/search/suggest?q=' + encodeURIComponent(q) +
        '&section_id=ocp-predictive-search' +
        '&resources[type]=product,query,collection&resources[limit]=8' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var s = doc.querySelector('[data-results-suggestions]');
          var p = doc.querySelector('[data-results-products]');
          if (sug) { sug.innerHTML = s ? s.innerHTML : ''; }
          if (prod) { prod.innerHTML = p ? p.innerHTML : ''; }
          ensureSuggestion(q);
          if (panel) { panel.classList.toggle('has-products', !!(prod && prod.querySelector('.psearch-card'))); }
        })
        .catch(function () {});
    }

    inputs.forEach(function (input) {
      input.addEventListener('focus', function () {
        if (mobileMq.matches && input.classList.contains('nav__search-input')) {
          outsideCloseAfter = Date.now() + 250;
        }
        show();
        setQueried(currentVal().length > 0);
        if (mobileMq.matches && input.classList.contains('nav__search-input')) {
          setTimeout(function () { input.blur(); }, 0);
        }
      });
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        syncVal(input.value, input);
        show();
        setQueried(q.length > 0);
        timer = setTimeout(function () { run(q); }, 250);
      });
    });
    var navSearchTrigger = wrap.querySelector('.nav__search');
    if (navSearchTrigger) {
      var openMobileSearch = function (event) {
        if (!mobileMq.matches) return;
        event.preventDefault();
        outsideCloseAfter = Date.now() + 250;
        show();
        setQueried(currentVal().length > 0);
        setTimeout(blurAll, 0);
      };
      navSearchTrigger.addEventListener('pointerdown', openMobileSearch);
      navSearchTrigger.addEventListener('click', openMobileSearch);
    }
    if (mobileTrigger) {
      mobileTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        outsideCloseAfter = Date.now() + 250;
        show();
        setQueried(currentVal().length > 0);
      });
    }
    if (close) { close.addEventListener('click', function () { hide(); blurAll(); }); }
    if (backdrop) { backdrop.addEventListener('click', function () { hide(); blurAll(); }); }

    document.querySelectorAll('.nav__menu-wrap--has-dropdown, .nav__item--has-children').forEach(function (item) {
      item.addEventListener('mouseenter', function () { hide(); });
      item.addEventListener('mouseover', function () { hide(); });
      item.addEventListener('pointerenter', function () { hide(); });
      item.addEventListener('focusin', function () { hide(); });
    });

    document.addEventListener('pointerover', function (event) {
      if (panel.hidden) return;
      if (event.target.closest && event.target.closest('.nav__menu-wrap, .nav__main')) {
        hide(); blurAll();
      }
    });

    // Popular-search pills: fill the input(s) and run predictive search inline (no page jump).
    wrap.querySelectorAll('.search-pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        var label = pill.querySelector('span');
        var term = (label ? label.textContent : pill.textContent).trim();
        syncVal(term);
        show();
        setQueried(term.length > 0);
        if (!mobileMq.matches) { focusVisible(); }
        run(term);
      });
    });

    document.addEventListener('click', function (e) {
      if (Date.now() < outsideCloseAfter) return;
      if (!wrap.contains(e.target)) hide();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); blurAll(); } });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
